import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { IUserRegisterGeneratePin } from '../../../entity/interface/iSubscription';

export interface IUserRegisterGeneratePinUseCase {
    execute(language: string, payload: IUserRegisterGeneratePin, apiToken: { [key: string]: string }): Promise<any>;
}

export class UserRegisterGeneratePinUseCase implements IUserRegisterGeneratePinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        language: string,
        payload: IUserRegisterGeneratePin,
        apiToken: { [key: string]: string }
    ): Promise<any> {
        return await this.subscriptionRepository.userRegisterGeneratePin(language, payload, apiToken);
    }
}
